import { render } from "./UserListDataTable.vue?vue&type=template&id=526265ad"
import script from "./UserListDataTable.vue?vue&type=script&lang=js"
export * from "./UserListDataTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__